import React, { useState, useEffect } from "react";
import { Link, useParams,useNavigate } from "react-router-dom";
import { Timeline } from 'primereact/timeline';
import { ProgressBar } from 'primereact/progressbar';
import "./HomeEvaluacion.scss"
import useUsuario from "../../../hooks/useUsuario";
import { ListarEvaluacionesUsuario} from "../../../service/DesarrolloService";
import Boton from "../../../components/Boton/Boton";

const HomeEvaluacion = () => {
    const navigate = useNavigate();
    const [timeline, setTimeline] = useState(null);
    const {permisos,isLogged}= useUsuario();
    const [permisoEditar, setPermisoEditar] = useState(false);

    useEffect(()=>{
        if (permisos.length > 0) {
            if (permisos.includes("editarEvaluaciones")) {
                setPermisoEditar(true);
            }

            // Ya no navegamos fuera, el padre controla esto
            if (!permisos.includes("verEvaluaciones")) {
                return;
            }
        }
    }, [permisos]);

    useEffect(()=>{
        const ObtenerTimeline = async () => {
            let jwt = window.localStorage.getItem("jwt");

            try {
                const data = await ListarEvaluacionesUsuario({ jwt });

                if (!data) {
                    setTimeline({ error: true });
                } else {
                    setTimeline(data);
                }
            } catch (e) {
                setTimeline({ error: true });
            }
        };

        ObtenerTimeline();
    }, []);

    if (!timeline) {
        return <div style={{ color: "#000" }}>Cargando información...</div>;
    }

    if (timeline.error) {
        return <div style={{ color: "red" }}>No hay información para mostrar.</div>;
    }

    
    const events = [
        { nombreEtapa: 'Enero', estado :'FinalizadoX', evaluaciones:[{nombreEvaluacion:"Retro de fin de año",estado:"Evaluado"}]},
        { nombreEtapa: 'Febrero', estado :'Finalizado', evaluaciones:[{nombreEvaluacion:"KPIs 2023",estado:"Evaluado"}] },
        { nombreEtapa: 'Marzo',  estado :'Finalizado', evaluaciones:[{nombreEvaluacion:"Medición potencial",estado:"Evaluado"}] },
        { nombreEtapa: 'Abril',  estado :'Actual', evaluaciones:[{nombreEvaluacion:"Evaluación 361",estado:"Evaluado"},
                                                            {nombreEvaluacion:"Evaluación 362",estado:"En proceso"},
                                                             {nombreEvaluacion:"Evaluación 363",estado:"En proceso"}]},
        { nombreEtapa: 'Mayo', estado :'Pendiente', evaluaciones:[{nombreEvaluacion:"Evaluación",estado:"Pendiente"}]},
        { nombreEtapa: 'Junio',  estado :'Pendiente', evaluaciones:[{nombreEvaluacion:"Feedback medio año",estado:"Pendiente"}] },
        { nombreEtapa: 'Julio',  estado :'Finalizado', evaluaciones:[{nombreEvaluacion:"Feedback medio año",estado:"Pendiente"}] },
        { nombreEtapa: 'Agosto',  estado :'Actual', evaluaciones:[{nombreEvaluacion:"Feedback medio año",estado:"Pendiente"}] },
        { nombreEtapa: 'Setiembre',  estado :'Pendiente', evaluaciones:[{nombreEvaluacion:"Feedback medio año",estado:"Pendiente"}] },
        { nombreEtapa: 'Octubre',  estado :'Pendiente', evaluaciones:[{nombreEvaluacion:"Feedback medio año",estado:"Pendiente"}] },
        { nombreEtapa: 'Noviembre',  estado :'Pendiente', evaluaciones:[{nombreEvaluacion:"Feedback medio año",estado:"Pendiente"}] },
        { nombreEtapa: 'Diciembre',  estado :'Pendiente', evaluaciones:[{nombreEvaluacion:"Feedback medio año",estado:"Pendiente"}] },

    ];
    const totalItems = events.length;

    const numberOfActiveItems = events.filter(o => o.estado =='Finalizado').length;
    const progressBarWidth =
      totalItems > 1 && numberOfActiveItems > 0
        ? ((numberOfActiveItems+1) / (totalItems))*100
        : 0;

    const handleClicMes =(nombre)=>{
        alert(nombre)
    }
    
    const customizedMarker = (item) => {
        return (
            <>        
                <div
                    className={"p-eva-timeLineMarker " + item.estado}
                    onClick={() => handleClicMes(item.nombreEtapa)}
                >                
                    <span className="font-bold text-sm">
                        {item.nombreEtapa} 
                    </span>
                </div>

                <div className={"p-timeline-event-connectorEva " + item.estado}></div>
            </>
        );
    };

    const customizedOpposite = (item) => {
        return (
            <div className="p-eva-opposite">
                {item.evaluaciones.map((e, i) => (
                    <div
                        key={i}
                        className={"timeLineContenido-evaluacion " + item.estado}
                    >
                        {e.nombreEvaluacion}
                    </div>
                ))}
            </div>
        );
    };


    const customizedContent = (item) => {
        return (
            <div className={"timeLineContenido-estado " + item.estado}>
                {item.estado}
            </div>
        );
    }; 

    //end esv 27-01-26

    //esv 11-02-26
    const hoy = new Date();
    const mesActual = hoy.getMonth(); // 0 = Enero

    const meses = [
        "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
        "Julio", "Agosto", "Setiembre", "Octubre", "Noviembre", "Diciembre"
    ];

    //busca en el mes que sigue 
    // const etapasConEstado = timeline?.etapas?.map((etapa) => {

    //     const indexMes = meses.indexOf(etapa.nombreEtapa);

    //     let nuevoEstado = "Pendiente";

    //     if (indexMes === 0) {
    //         nuevoEstado = "Finalizado";
    //     } 
    //     else if (indexMes < mesActual) {
    //         nuevoEstado = "Finalizado";
    //     } 
    //     else if (indexMes === mesActual) {
    //         nuevoEstado = "Iniciando";
    //     }

    //     return {
    //         ...etapa,
    //         estado: nuevoEstado
    //     };
    // });

    // Buscar el primer mes mayor al actual (la próxima evaluación)
    const siguienteMesIndex = timeline?.etapas
        ?.map(e => meses.indexOf(e.nombreEtapa))
        ?.filter(index => index > mesActual)
        ?.sort((a, b) => a - b)[0];

    const etapasConEstado = timeline?.etapas?.map((etapa) => {

        const indexMes = meses.indexOf(etapa.nombreEtapa);

        let nuevoEstado = "Por iniciar"; //"Pendiente";

        if (indexMes < mesActual) {
            nuevoEstado = "Finalizado";
        }
        else if (indexMes === mesActual) {
            nuevoEstado = "Iniciando";
        }
        else if (indexMes === siguienteMesIndex) {
            nuevoEstado = "Por inciar";
        }
        else {
            nuevoEstado = "Por iniciar";  //"Pendiente";
        }

        return {
            ...etapa,
            estado: nuevoEstado
        };
    });

    //esv 11-02-26

    return (
        <>
        <div style={{whiteSpace:"pre-line",marginTop:12,color:"#000000"}}>{timeline && timeline.descripcion}</div>

        {!timeline && <div style={{color:'red'}}>Cargando o timeline vacío</div>}

         <div className="p-eva-timeLine">
            {
                timeline &&
                <>
                    {/* <ProgressBar value={progressBarWidth} color="#00B560" aria-aria-valuemax={12} style={{ height: 1, marginLeft: 70, marginRight: 70}} showValue={false} />  */}
                    <Timeline 
                        className="p-eva-timeLine-items" 
                        // value={timeline.etapas} //esv 11-02-26
                        value={etapasConEstado}  //esv 11-02-26
                        
                        layout="horizontal"
                        content={customizedContent}
                        opposite={customizedOpposite}
                        marker={customizedMarker} 
                        //style={{ marginTop: -48 }} 
                    />                    
                </>                
            }
        </div> 
        {
            timeline &&
            <div className="timeline-seccion-link">
                <div className="seccion-link-texto">{timeline.sigueAhora}</div>
                <div style={{display:"flex",justifyContent:"center"}}><Boton nombre={timeline.textoBoton} color="secondary" widths="248px"
                    metodoClick={() => window.open(timeline.link.indexOf("http") > -1 ? timeline.link : "http://"+timeline.link, "_blank", "noopener,noreferrer")}
                ></Boton>
                </div>
                        
            </div>
        } 
        
        </>
       
    );
}
 
export default HomeEvaluacion;